import { render, staticRenderFns } from "./69.vue?vue&type=template&id=61524d0a&scoped=true&"
var script = {}
import style0 from "./69.vue?vue&type=style&index=0&id=61524d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61524d0a",
  null
  
)

export default component.exports